import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ContactMessageService from "../../Services/QRCodeServices/ContactMessageService/ContactMessageService";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Card, Col, Row } from "reactstrap";

const DetailMessage = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ContactMessageService.detail(id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <BreadCrumb
            pageTitle="Contact Message"
            title="Contact Message Detail"
            breadcrumbItems={[
              { title: "Back To List ", link: "/contact-message" },
            ]}
          />
        </div>
        <div className="justify-content-center align-items-center align-content-center">
        <Card className="p-3 col-md-8 ">
          <Row>
            <Col md={12} xs={12} className="mb-2">
              <h5 className="fw-bold">
                Organization Code: <span>{data?.orgCode}</span>
              </h5>
            </Col>
            <Col md={6} xs={12} className="mb-2">
              <h5 className="fw-bold">Name: </h5>
              <h6 className="fw-normal">{data?.name}</h6>
            </Col>
            <Col md={6} className="mb-2">
              <h5 className="fw-bold">Email:</h5>
              <h6 className="fw-normal">{data?.email}</h6>
            </Col>
            <Col md={12} xs={12} className="mb-2">
              <h5 className="fw-bold">Message:</h5>
              <p className="fw-normal">{data?.message}</p>
            </Col>
          </Row>
        </Card>
        </div>

      </div>
    </div>
  );
};

export default DetailMessage;
